import * as Immutable from 'immutable';

export type ProductPublishJobStatus = 'pending'|'processing'|'published'|'failed'|'cancelled'

export type ProductPublishErrorSlug =
	'product_publish_error_unsupported_store'|
	'product_publish_error_store_not_found'|
	'product_publish_error_store_owner_mismatch'|
	'product_publish_error_store_flagged'|
	'product_publish_error_store_missing_scope'|
	'product_publish_error_invalid_payload'|
	'product_publish_error_invalid_product_design'|
	'product_publish_error_api'|
	'product_publish_error_etsy_shop_frozen'|
	'product_publish_error_shopify_daily_variant_limit'|
	'product_publish_error_unexpected'|
	'product_publish_error_unknown'|
	'product_publish_error_interrupted_after_external_call'|
	'product_publish_error_interrupted_before_external_call'

export interface ProductPublishJobPayload {
	id: number,
	batch_id: string,
	id_product: number,
	id_product_design: number,
	title: string,
	thumbnail: string|null,
	status: ProductPublishJobStatus,
	attempts: number,
	can_retry: boolean,
	error_slug: ProductPublishErrorSlug|null,
	store_slug: string,
	id_store: number,
	date_created?: string,
	date_updated?: string,
	date_finished?: string|null,
	date_cleared?: string|null,
}

export interface IProductPublishJobStore {
	id: number,
	batch_id: string,
	id_product: number,
	id_product_design: number,
	title: string,
	thumbnail: string|null,
	status: ProductPublishJobStatus,
	attempts: number,
	can_retry: boolean,
	error_slug: ProductPublishErrorSlug|null,
	store_slug: string,
	id_store: number,
}

const defaultProductPublishJobStore = Immutable.Record<IProductPublishJobStore>({
	id: 0,
	batch_id: '',
	id_product: 0,
	id_product_design: 0,
	title: '',
	thumbnail: null,
	status: 'pending',
	attempts: 0,
	can_retry: false,
	error_slug: null,
	store_slug: '',
	id_store: 0,
});

export default class ProductPublishJobStore extends defaultProductPublishJobStore implements IProductPublishJobStore {}
